'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["resolverOptions"];
import { ALL_OBJECT_PROPERTIES as ALL_OBJECT_PROPERTIES_CACHE_KEY } from 'reference-resolvers/constants/CacheKeys';
import { ALL_OBJECT_PROPERTIES } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { createCustomKey } from 'reference-resolvers/lib/CustomKey';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { createGetAllProperties, getAllProperties } from 'reference-resolvers/api/PropertiesAPI';
export const toAllObjectPropertiesReferenceObjectType = objectTypeId => createCustomKey(ALL_OBJECT_PROPERTIES, objectTypeId);
export const createAllObjectPropertiesReferenceResolver = (objectTypeId, {
  resolverOptions,
  fetchQueryParams
} = {}) => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: createCustomKey(ALL_OBJECT_PROPERTIES_CACHE_KEY, objectTypeId),
  createFetchData: opts => createGetAllProperties(opts)(objectTypeId, {
    queryParams: fetchQueryParams
  }),
  fetchData: getAllProperties(objectTypeId, {
    queryParams: fetchQueryParams
  })
}, resolverOptions));
export default ((objectTypeId, options) => {
  const opts = _objectWithoutPropertiesLoose(options, _excluded);
  return createAllObjectPropertiesReferenceResolver(objectTypeId, opts);
});